/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface SetExecutionToAbandoned$Params {
  jobExecutionId: number;
  stepExecutionId: number;
}

export function setExecutionToAbandoned(
  http: HttpClient,
  rootUrl: string,
  params: SetExecutionToAbandoned$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setExecutionToAbandoned.PATH, 'patch');
  if (params) {
    rb.path('jobExecutionId', params.jobExecutionId, {});
    rb.path('stepExecutionId', params.stepExecutionId, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    }),
  );
}

setExecutionToAbandoned.PATH = '/manage/job/execution/{jobExecutionId}/{stepExecutionId}/setAbandoned';
